module.exports = __webpack_public_path__ + "media/2.5d03505c.mp3";